<template>
    <div>
        <base-form
            ref="form"
            v-model="form"
            :api="api"
            :mapper="mapper"
            :entity-id="entityId"
            :title="title"
            :disabled="disabled"
            @created="created"
            @updated="updated"
            @cancelled="cancelled"
            @deleted="deleted"
        >
            <form-panel>
                <!-- restaurant: selectable on create, locked on edit -->
                <form-one-col-row>
                    <entity-select-input
                        v-if="!isEdit"
                        v-model="form.restaurant"
                        v-validate="'required'"
                        :entity="selectApiClientType.RESTAURANT"
                        label="labels.restaurant"
                        name="restaurant"
                        :error-messages="errors.collect('restaurant')"
                        :data-vv-as="$t('labels.restaurant')"
                        :clearable="false"
                        autocomplete
                    ></entity-select-input>
                    <text-input
                        v-else
                        :value="form.restaurantName"
                        label="labels.restaurant"
                        name="restaurantDisplay"
                        disabled
                    ></text-input>
                </form-one-col-row>

                <!-- allowed meals -->
                <form-one-col-row>
                    <entity-select-input
                        v-model="form.mealCodes"
                        :entity="selectApiClientType.MEAL"
                        :query-params="{ restaurant: form.restaurant }"
                        :request-disabled="!form.restaurant"
                        label="labels.allowed_meals"
                        name="mealCodes"
                        use-code-field
                        multi-select
                        autocomplete
                    ></entity-select-input>
                    <div class="g-b2--text">
                        {{ $t('texts.allowed_meals_empty_hint') }}
                    </div>
                </form-one-col-row>
            </form-panel>
        </base-form>
    </div>
</template>

<script>
import routeType from '@/router/routeType'
import ApiClientType from '@/api/RestApiType'
import MapperType from '@/services/mapper/MapperType'
import RestApiCollection from '@/api/RestApiCollection'
import FormBase from '@/components/mixins/FormBase'
import AuthMixin from '@/components/mixins/AuthMixin'
import FormPanel from '@/components/form/FormPanel.vue'
import FormOneColRow from '@/components/form/FormOneColRow.vue'
import TextInput from '@/components/form/Inputs/TextInput.vue'
import EntitySelectInput from '@/components/form/Inputs/EntitySelectInput.vue'

export default {
    components: {
        FormPanel,
        FormOneColRow,
        TextInput,
        EntitySelectInput,
    },
    mixins: [FormBase, AuthMixin],
    props: {
        companyId: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            api: ApiClientType.COMPANY_ALLOWED_MEALS,
            mapper: MapperType.COMPANY_ALLOWED_MEALS_FORM,
            form: {
                company: null,
                restaurant: null,
                restaurantName: null,
                mealCodes: [],
            },
            entity: 'labels.allowed_meal',
            editRoute: routeType.COMPANY_ALLOWED_MEAL_EDIT,
            listRoute: routeType.COMPANY_ALLOWED_MEAL_LIST,
            companyApiClient: RestApiCollection.get(ApiClientType.COMPANIES),
        }
    },
    computed: {
        isEdit() {
            return !!this.entityId
        },
        title() {
            return this.form.restaurantName || this.$t('labels.allowed_meal')
        },
    },
    created() {
        this.form.company = this.companyApiClient.getItemIri(this.companyId)
    },
    methods: {
        editRedirectParams(data) {
            return {
                allowedMealId: data.id,
                companyId: this.companyId,
            }
        },
        listRedirectParams() {
            return { companyId: this.companyId }
        },
    },
}
</script>
